import React from 'react';
import './PulseUpload.css';


const PulseUpload = ({ icon, size }) => {
  return (
        <div 
            className='pulse-wrapper'
            style={{ width: size, height: size, fontSize: size }}
        >
            
            <div className='shadow'>
                {icon}
            </div>
            
            <div className='icon'>
                {icon}
            </div>

        </div>
    );
};

export default PulseUpload;
